/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

/**
 * @fileoverview
 * @deprecated Use /lib/lit/decorators.js instead.
 */

export * from '../lit/decorators.js';
